export default "__VITE_ASSET__CIOcZ$3b__"